import { arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isPersonalizationExplainerAvailableDimensionsResult = arrayOf(string);
